// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IHealthPlanEnrollmentSummaryRecordDto } from './IHealthPlanEnrollmentSummaryRecordDto';
import {
    IHealthPlanEnrollmentSummaryRecordDtoFromJSON,
    IHealthPlanEnrollmentSummaryRecordDtoFromJSONTyped,
    IHealthPlanEnrollmentSummaryRecordDtoToJSON,
    IHealthPlanEnrollmentSummaryRecordDtoToJSONTyped,
} from './IHealthPlanEnrollmentSummaryRecordDto';
import type { IReportSummaryGroupDtoHealthPlanEnrollmentSummaryRecordDto } from './IReportSummaryGroupDtoHealthPlanEnrollmentSummaryRecordDto';
import {
    IReportSummaryGroupDtoHealthPlanEnrollmentSummaryRecordDtoFromJSON,
    IReportSummaryGroupDtoHealthPlanEnrollmentSummaryRecordDtoFromJSONTyped,
    IReportSummaryGroupDtoHealthPlanEnrollmentSummaryRecordDtoToJSON,
    IReportSummaryGroupDtoHealthPlanEnrollmentSummaryRecordDtoToJSONTyped,
} from './IReportSummaryGroupDtoHealthPlanEnrollmentSummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryDtoHealthPlanEnrollmentSummaryRecordDto
 */
export interface IReportSummaryDtoHealthPlanEnrollmentSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSummaryDtoHealthPlanEnrollmentSummaryRecordDto
     */
    employer_name?: string;
    /**
     * 
     * @type {Array<IHealthPlanEnrollmentSummaryRecordDto>}
     * @memberof IReportSummaryDtoHealthPlanEnrollmentSummaryRecordDto
     */
    employer_records?: Array<IHealthPlanEnrollmentSummaryRecordDto>;
    /**
     * 
     * @type {Array<IReportSummaryGroupDtoHealthPlanEnrollmentSummaryRecordDto>}
     * @memberof IReportSummaryDtoHealthPlanEnrollmentSummaryRecordDto
     */
    subsidiary_groups?: Array<IReportSummaryGroupDtoHealthPlanEnrollmentSummaryRecordDto>;
}

/**
 * Check if a given object implements the IReportSummaryDtoHealthPlanEnrollmentSummaryRecordDto interface.
 */
export function instanceOfIReportSummaryDtoHealthPlanEnrollmentSummaryRecordDto(value: object): value is IReportSummaryDtoHealthPlanEnrollmentSummaryRecordDto {
    return true;
}

export function IReportSummaryDtoHealthPlanEnrollmentSummaryRecordDtoFromJSON(json: any): IReportSummaryDtoHealthPlanEnrollmentSummaryRecordDto {
    return IReportSummaryDtoHealthPlanEnrollmentSummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryDtoHealthPlanEnrollmentSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryDtoHealthPlanEnrollmentSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'employer_records': json['employer_records'] == null ? undefined : ((json['employer_records'] as Array<any>).map(IHealthPlanEnrollmentSummaryRecordDtoFromJSON)),
        'subsidiary_groups': json['subsidiary_groups'] == null ? undefined : ((json['subsidiary_groups'] as Array<any>).map(IReportSummaryGroupDtoHealthPlanEnrollmentSummaryRecordDtoFromJSON)),
    };
}

export function IReportSummaryDtoHealthPlanEnrollmentSummaryRecordDtoToJSON(json: any): IReportSummaryDtoHealthPlanEnrollmentSummaryRecordDto {
    return IReportSummaryDtoHealthPlanEnrollmentSummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryDtoHealthPlanEnrollmentSummaryRecordDtoToJSONTyped(value?: IReportSummaryDtoHealthPlanEnrollmentSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employer_name': value['employer_name'],
        'employer_records': value['employer_records'] == null ? undefined : ((value['employer_records'] as Array<any>).map(IHealthPlanEnrollmentSummaryRecordDtoToJSON)),
        'subsidiary_groups': value['subsidiary_groups'] == null ? undefined : ((value['subsidiary_groups'] as Array<any>).map(IReportSummaryGroupDtoHealthPlanEnrollmentSummaryRecordDtoToJSON)),
    };
}

